// Image URL helper - resolves relative paths to full API URLs
const API_URL = process.env.REACT_APP_BACKEND_URL;

export const resolveImageUrl = (url) => {
  if (!url) return '';
  // Already a full URL
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  // Relative path like /uploads/xxx.jpg -> full API URL
  if (url.startsWith('/uploads/')) return `${API_URL}/api${url}`;
  // Just a filename
  return `${API_URL}/api/uploads/${url}`;
};
